module.exports = __webpack_public_path__ + "img/03.f226964f.png";